export const namespace = 'alert/';

export const AlertGetters = {
  GET_ALERTS: namespace + 'getAlerts'
};

export const AlertActions = {
  FETCH_ALERTS: namespace + 'fetchAlerts',
  UPDATE_EMPLOYEE_ALERTS: namespace + 'updateEmployeeAlerts'
};

export const AlertMutations = {
  SET_ALERTS: namespace + 'setAlerts',
  SET_ALERTS_VIEWED: namespace + 'setAlertsViewed'
};
